/**
 * Widget Configurator Sample
 * The input and output of the configurator is the profile of its corressponding
 * widget.
 * @author zyz
 * @created 03/22/2016
 */

require('./index.less');

const activator = {
    init: function() {

    },

    /**
     * @setProfile {Function} [required] Will be called when user decides to
     * config the widget on workbench.
     * @param {Object} profile The profile of corresponding widget.
     */
    setProfile: function(profile) {
        if (!profile) {
            return;
        }
    },
    /**
     * @getProfile {Function} [required] Will be called when user click the save
     * button which is on the bottom of the configurator dialog.
     * @return {Object} profile
     */
    getProfile: function() {
        return {
          name: 'tj',
        };
    },
    /**
     * @isProfileOK {Function} [optional] This function is responsible for
     * checking the validation of the widget profile, and giving the tips
     * to user via various message box and return false if the profile is
     * invalid. This method will be called when user click the save button
     * of the configurator dialog before calling the method of [getProfile]
     * . Note that no validation process before saving profile if this method
     * is not implemented.
     * @return {Boolean}
     */
    isProfileOK: function() {
        if (true) {
            alert('activator.isProfileOK method is called and true is returned');
            return true;
        } else {
            alert('You should set ... so that..');
            return false;
        }
    },

    /**
     * @getSupportedEventList {Function} [optional] This method will be called if
     * implemented when the user click the save button to gather the events which
     * will be triggered in runtime by the widget instance. Note that the supported
     * events would be different with the different profiles configurated by user in
     * the same type widget.
     * @return {Array<Object>} EventList
     */
    getSupportedEventList: function() {
        // TODO: Add your code here to return different event list following
        // current configurated profile.

        // Event list example
        return [{
            // Event Id [required]
            id: "onselectrow",
            // Event Name [required] Maybe you can set it as the same as the id.
            name: "On Select Row",
            // Event Description [optional]
            // Maybe a i18n is needed to describe the event in variables languages.
            des: "Triggered when user select a row"
        }, {
            id: "ondblclickrow",
            name: "On DbClick Row",
            des: "Triggered when user double click the row"
        }, {
            //...
        }];
    },
    /**
     * @getSupportedVariableList {Function} [optional] This method will be called if
     * implemented when the user click the save button, to gather the variables owned
     * by the widget instance. Note that the supported variables would be different with
     * the different profiles configurated by user in the same type widget.
     * @return {Array<Object>} VariableList
     **/
    getSupportedVariableList: function() {

        // TODO: Add your code here to return different variable list following
        // current configurated profile.

        // Variable list example
        return [{
            // Variable name [required]
            name: 'rowid',
            // Variable type [optional default string]
            type: 'string',
            // Variable description
            des: 'Current selected row id.'
        }, {
            name: 'price',
            type: 'number',
            des: 'The money the user input currently'
        }, {
            // ...
        }];
    },
    /**
     * @getDependentVariableList {Function} [optional] This method is repsonsible
     * for gathering the dependent variables of the widget from context.
     * @return {Array<String>}
     */
    getDependentVariableList: function() {
        // Variable List example
        return [
            '1-userid',
            '11-curr_user_name'
        ];
    },
    /**
     * @getWidth {Function} [optional] Get the width of the widget following
     * current configurated widget so that the width of window wrapper can be
     * auto adapted. If not implemented, your widget should adapter automatically
     * the width of outer window.
     * @return {Number}
     */
    getWidth: function() {},

    /**
     * @getHeight {Function} [optional] Get the Height of the widget following
     * current configurated widget so that the Height of window wrapper can be
     * auto adapted. If not implemented, your widget should adapter automatically
     * the Height of outer window.
     * @return {Number}
     */
    getHeight: function() {}

    // Considering...
    // /**
    //  * [getDependentDatasourceList description]
    //  * @return {[type]} [description]
    //  */
    // getDependentDatasourceList: function() {},
    // /**
    //  * [getDependentProcedureList description]
    //  * @return {[type]} [description]
    //  */
    // getDependentProcedureList: function() {},
};


// Excute after dom ready.
$(function() {

    // Init dom
    activator.init();

    // Export to window so that the father window can access this activator.
    window.activator = activator;
});



// WEBPACK FOOTER //
// ./src/index.js